import React from "react";

const FREE_TIER_HINT = /free|basic|no plan/i;

const PlanBadge = ({ plan }) => {
  const isFreeTier = FREE_TIER_HINT.test(plan || "");
  return (
    <span
      className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${
        isFreeTier ? "bg-gray-100 text-gray-700" : "bg-indigo-100 text-indigo-700"
      }`}
    >
      {plan}
    </span>
  );
};

export default PlanBadge;
